(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmfa-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bmfa-slideshow')){
customElements.define('bmfa-slideshow',class extends HTMLElement{
connectedCallback(){
this.slides=[...this.querySelectorAll('.bmfa-home-slide')];this.dots=[...this.querySelectorAll('[data-dot]')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.querySelector('[data-prev]')?.addEventListener('click',()=>this.move(this.index-1));
this.querySelector('[data-next]')?.addEventListener('click',()=>this.move(this.index+1));
this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.move(i)));
this.toggle=this.querySelector('[data-pause]');this.toggle?.addEventListener('click',()=>{this.paused=!this.paused;this.start();});
this.addEventListener('focusin',()=>clearInterval(this.timer));this.addEventListener('focusout',()=>this.start());this.start();
}
move(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>slide.hidden=i!==this.index);this.dots.forEach((dot,i)=>{if(i===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});}
start(){clearInterval(this.timer);if(this.toggle)this.toggle.textContent=this.paused?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel;if(!this.paused&&this.slides.length>1)this.timer=setInterval(()=>{if(!document.hidden&&!this.contains(document.activeElement))this.move(this.index+1);},5500);}
disconnectedCallback(){clearInterval(this.timer);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
